import React from 'react';
import {inject, observer} from 'mobx-react';
import Agent from '../../api/agent'
import ReCAPTCHA from "react-google-recaptcha";
import {validateIfInputIsEmail} from '../../helpers/validationChecks'

const recaptchaRef = React.createRef();
const captchaSiteKey = '6LcCF7QUAAAAAORc8GBjqpr0XmTzoDS4E9l1DY89';


@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class CommissionRequestSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: localStorage.getItem("full_name"),
            email: localStorage.getItem("primary_email") || localStorage.getItem("fb_email") || localStorage.getItem("goog_email") || localStorage.getItem("login_email"),
            type: "Commissioning work",
            status: 1,
            message: ''
        }
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handleCommissioningRequest() {

        if (!this.state.name) {
            this.props.navigatorStore.openErrorModal("Entering name is mandatory.")
            return;
        }
        if (!this.state.email) {
            this.props.navigatorStore.openErrorModal("Entering email is mandatory.")
            return;
        }
        if (!!this.state.email && !validateIfInputIsEmail(this.state.email)) {
            this.props.navigatorStore.openErrorModal("Please enter a valid email.")
            return;
        }
        // if (!this.state.captchaDone) {
        //     this.props.navigatorStore.openErrorModal("Please complete the captcha before sending a request.")
        //     return;
        // }
        this.executeRecaptcha();

    }


    commissionRequestAPI = () => {
        var formData = new FormData();
        formData.append("name", this.state.name)
        formData.append("email", this.state.email)
        formData.append("type", this.state.type)
        formData.append("message", this.state.message)
        // formData.append("status", this.state.status)
        Agent.generalData.commissioningRequest(formData)
            .then((res) => {
                if (res.error == "False") {
                    this.props.navigatorStore.openErrorModal("We have received your request, we will get back to you soon", false, false, true)
                    this.setState({
                        name: "",
                        email: "",
                        type: "Commissioning work",
                        message: "",
                    })
                    // this.executeRecaptcha();
                }
            })
    }

    handleRequestTypeSelect(event) {
        this.setState({
            type: event.target.value
        })
    }


    handleRecaptchaChange = value => {
        if (value === null) {
            this.googleCaptchaError();
        }
        this.commissionRequestAPI();
        ReCAPTCHA.reset();
    };

    executeRecaptcha = () => {
        if (recaptchaRef) {
            recaptchaRef.current.reset();
        }
        recaptchaRef.current.execute();
        this.setState({
            captchaDone: false
        })
    };


    googleCaptchaError = () => {
        this.props.navigatorStore.openErrorModal("Google Captcha Failed", false, false, true)
        return false;
    };


    render() {
        return (
            <div style={{backgroundColor: this.props.colored ? "#F6F6F6" : "#fffff"}}>
                <div className="rectangle-featured-artworks pb-25"
                     style={{backgroundColor: this.props.colored ? "#F6F6F6" : "#fffff"}}>
                    <div style={{display: "flex"}}>
                        <div className="title-featured-artworks mt-15" style={{margin: "unset", flex: "1"}}>
                            COMMISIONING & ARTWORK REQUESTS
                            <hr className="line-category-name "></hr>
                            {/* {this.state.name} {this.state.email} */}
                            <p className="heading-desc-text">
                                Interested in bulk buying of artworks or commissioned works? Send us your message and we
                                will contact you with further details.
                            </p>

                            <div className="row mt-25 mb-25">
                                <div className="col-md-4 mb-15">
                                    <div className="form-group">
                                        <label htmlFor="">YOUR NAME</label>
                                        <input type="text" className="form-control" name="name"
                                               onChange={this.handleInputChange.bind(this)}
                                               style={{background: !this.props.colored ? "#F6F6F6" : "#fffff"}}
                                               value={this.state.name} placeholder="John Doe"/>
                                    </div>
                                </div>
                                <div className="col-md-4 mb-15">
                                    <div className="form-group">
                                        <label htmlFor="">YOUR EMAIL</label>
                                        <input className="form-control"
                                               style={{background: !this.props.colored ? "#F6F6F6" : "#fffff"}}
                                               onChange={this.handleInputChange.bind(this)}
                                               value={this.state.email}
                                               name="email"
                                               type="email"
                                               placeholder="exmail@example.com"/>
                                    </div>
                                </div>
                                <div className="col-md-4 mb-15">
                                    <div className="form-group">
                                        <label htmlFor="">REQUEST TYPE</label>
                                        <br/>
                                        <select
                                            // type="select"
                                            style={{background: !this.props.colored ? "#F6F6F6" : "#fffff"}}
                                            value={this.state.type} onChange={this.handleRequestTypeSelect.bind(this)}
                                            placeholder="" name="requestType">
                                            <option value="Commissioning work">Commissioning work</option>
                                            <option value="Sales requests">Sales requests</option>
                                        </select>

                                    </div>
                                </div>

                                <div className="col-md-8">
                                    <div className="form-group">
                                        <label htmlFor="">Message</label>
                                        <input type="text" className="form-control" name="message"
                                               onChange={this.handleInputChange.bind(this)}
                                               placeholder="Please type message"/>
                                    </div>
                                </div>


                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="invisible"
                                    sitekey={captchaSiteKey}
                                    onChange={this.handleRecaptchaChange}
                                    onErrored={this.googleCaptchaError}/>

                                <div className="col-md-4 mb-15">
                                    <div className="form-group">
                                        <label htmlFor="">&nbsp; &nbsp;</label>
                                        <br/>
                                        <button
                                            onClick={this.handleCommissioningRequest.bind(this)}
                                            className="masterpieces-primary-buttons button request-btn">
                                            REQUEST
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/sectionHolders/comissionRequestSection.js